export default "__VITE_ASSET__4U3s155G__"